export type StringColor = 'WHITE' | 'BLACK';

export enum TableSides {
  SOUTH = 'SOUTH',
  NORTH = 'NORTH',
}

export enum PlayerColors {
  BLACK = 'BLACK',
  WHITE = 'WHITE',
}

export type AdditionalPlayerInfo = {
  //всего турниров
  tourneysTotal: number;
  //в том числе призовые места
  tourneysTop1: number;
  tourneysTop2: number;
  tourneysTop3: number;
  //мини-турниры
  miniTourneys: number;
  //победы в мини турниках
  miniTourneysWin: number;
  ladderRanking: number;
  totalGames: number;
  won: number;
  lost: number;
  maxRating: number;
};

export type Coordinates = {
  x: number;
  y: number;
};

export type Size = {
  width: number;
  height: number;
};
